import { posts } from "assets/data/posts";
import { FeedPost } from "components";
import ReportPostsLayout from "layouts/ReportPostsLayout";

const CopyrightsReports = () => {
    return (
        <ReportPostsLayout
            breadCrumbTitle="Copyright Violation"
            title="Copyright Violation Posts Reports"
        >
            <>
                {posts.slice(3, 6).map((i) => (
                    <FeedPost post={i} key={i.id} />
                ))}
            </>
        </ReportPostsLayout>
    );
};

export default CopyrightsReports;
